<!--  -->
<template>
  <div class="mydata">
    <h3>导出记录</h3>
    <div class="content">
      <el-table
        :data="tableData"
        :header-cell-style="{
          background: '#f1f5f7',
          color: '#999999',
        }"
        fit
      >
        <el-table-column prop="datetime" label="创建日期" min-width="200" align="center"></el-table-column>
        <el-table-column prop="keyword" label="数据概况" min-width="300" align="left"></el-table-column>
        <el-table-column prop="exquantity" label="数据数量" min-width="200" align="center"></el-table-column>
        <el-table-column prop="payinformation" label="支付信息" align="center"></el-table-column>
        <el-table-column label="操作" align="left" prop="downloadlink">
          <template slot-scope="scope">
            <a :href="'//' + url + scope.row.downloadlink">下载</a>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination
          background
          layout="total,prev, pager, next"
          :page-size="15"
          :total="total"
          @current-change="handleCurrentChange"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import tool from '../../tool/tool'
import { API_1, Global } from '@/conf/api'
export default {
  //import引入的组件需要注入到对象中才能使用
  name: 'mydata',
  components: {},
  data() {
    //这里存放数据
    return {
      url: 'qxchuhai.com/',
      tableData: [],
      total: 0,
      pages: 1,
    }
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    handleCurrentChange(val) {
      let top = document.documentElement.scrollTop || document.body.scrollTop
      document.body.scrollTop = document.documentElement.scrollTop = 0
      // 实现滚动效果
      if (top <= 0) {
        document.body.scrollTop = document.documentElement.scrollTop = top -= 50
      }
      this.pages = val
      this.getData()
    },
    getData() {
      let params = this.$qs.stringify({
        userid: tool.getCookie('user'),
        pages: this.pages,
      })
      this.axios
        .post(API_1 + Global.mydata, params)
        .then((res) => {
          if (res.data.status == 1) {
            if (res.data.data) {
              this.tableData = res.data.data.list
              this.total = res.data.data.total
            }
          } else {
            this.$message({
              message: res.data.msg,
              type: 'error',
              offset: 100,
            })
          }
        })
        .catch((res) => {
          this.$message({
            message: '网络连接失败，请刷新重试',
            type: 'error',
            offset: 100,
          })
        })
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.getData()
    this.$emit('status', 2)
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang="scss" scoped>
//@import url(); 引入公共css类
.mydata {
  .pagination {
    margin-top: 10px;
    border-radius: 6px;
    padding: 15px 40px;
    text-align: center;
    /deep/li {
      background: #f4f4f4;
      color: #666;
    }
    /deep/.active {
      background: #0f4d72 !important;
      color: #fff;
    }
  }
  // width: 1610px;
  height: 910px;
  background-color: #ffffff;
  margin: 10px;
  padding-top: 30px;
  /deep/ .el-table__empty-text {
    display: block;
    width: 500px;
    height: 385px;
    padding-top: 300px;
    background: url('../../assets/nothing.png') no-repeat center center;
    background-size: auto;
    font-size: 20px;
    box-sizing: border-box;
    color: #a3bed7;
  }
  h3 {
    width: 73px;
    height: 20px;
    font-family: MicrosoftYaHei;
    font-size: 18px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 20px;
    letter-spacing: 0px;
    color: #0f4d72;
    padding-left: 10px;
    border-left: 4px solid #0f4d72;
    margin-left: 50px;
    margin-bottom: 30px;
  }
  .content {
    border-top: 1px solid #eee;
    text-align: left;
    padding: 40px 50px 10px 50px;
    background: #fff;
    a {
      color: #0f4d72;
      &:hover {
        color: #178cd1;
      }
    }
  }
}
</style>
